import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CompanyList } from '../const/company-list';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  _logo: string = '';

  constructor(private httpClient: HttpClient) { }

  /**
   * Método para buscar a imagem do logotipo da seguradora
   * 
   * @param company 
   * @returns 
   */
  getLogo(company: string): Observable<any> {
    // let insuranceData = JSON.parse(localStorage.getItem('insurance')) as any;
    // const data = of(insuranceData);
    let url = '../assets/images/logos';
    let img = '';
    
    switch(company) {
      case 'chubb':
        img = 'XMLID_11_.svg';
        break;
      default:
        img = '';
        break;
    }
    const data = of ((`${url}/${img}`) as string);

    return data;
  }

  // getLogoUrl(company: string): Observable<Blob> {
  //   let _urlImage = '../assets/images/logos';
  //   let _logo = '';
  //   switch(company) {
  //     case "chubb":
  //       _logo = "XMLD_11_.svg";
  //       break;
  //     default:
  //       _urlImage;
  //     break;
  //   }

  //   return this.httpClient.get(`${_urlImage}/${_logo}`, { responseType: 'blob' });
  // }

  getImage(imageUrl: string): Observable<Blob> {
    this._logo = "XMLID_11_.svg";

    return this.httpClient.get(`${imageUrl}/${this._logo}`, { responseType: 'blob' });
  }

  getBrandInsurance(id: string): string {
    let company = '';
    CompanyList.find(item => {
      if (item.cod === id)
        company = item.companyName;
    })
    return company;
  }
}
